module.exports = __webpack_public_path__ + "static/themepark-fbfff58ca89832213fbf9352fd0170b9.png";